import { useLogisticaConfiguration, withLogisticaConfiguration } from "../configurazione/LogisticaConfigurationProvider";
import { useEffect, useState } from "react";
import axios from "axios";
import Ordinidelgiorno from "./DashboardOrdiniComponenti/Ordinidelgiorno";
import StoricoOrdini from "./DashboardOrdiniComponenti/StoricoOrdini";
import apiUrl from "../../Apiurl";
import RiquadroEspandibile from "./DashboardOrdiniComponenti/RiquadroEspandibile";
import StatSpedAnni from "../../statistiche/StatSpedAnni";
import StatSpedMarketplaces from "../../statistiche/StatSpedMarketplaces";
import StatSpedCorrieri from "../../statistiche/StatSpedCorrieri";
import StatSpedMotiviAnnullamenti from "../../statistiche/StatSpedMotiviAnnullamenti";
import StatSpedGraneMarketplace from "../../statistiche/StatSpedGraneMarketplace";
import stilePulsanti from "../../interfaccia/stilePulsanti";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { LineChart } from "@mui/x-charts/LineChart";
import { cheerfulFiestaPalette } from "@mui/x-charts/colorPalettes";
import SettingBooleano from "../../statistiche/SettingBooleano";
import StatSpedPaesi from "./StatSpedPaesi";
import StatTrendFacet from "./StatTrendFacet";
import StatTrendSharing from "./StatTrendSharing";
import StatTrendConfronta from "./StatTrendConfronta";
import StatDatiConfronta from "./StatDatiConfronta";
import StatDatiGraneCorrieri from "./StatDatiGraneCorrieri";
import StatControlloFattureCorrieri from "./StatControlloFattureCorrieri";
import StatIncassiSpedizioni from "./StatIncassiSpedizioni";
import { dashboardOrdiniSectionCaptions } from "./dashboardOrdiniMeta";
import {
  BlockSkeleton,
  DonutChartSkeleton,
} from "../../interfaccia/loading";

function DashboardPieGroupSkeleton() {
  return (
    <div className="flex flex-wrap items-start justify-center">
      {Array.from({ length: 5 }).map((_, index) => (
        <div
          key={`dashboard-pie-${index}`}
          className="pa2 w-100 w-20-l flex flex-column items-center"
        >
          <BlockSkeleton tone="soft" width={140} height={16} className="mb3" />
          <DonutChartSkeleton
            tone="soft"
            height={330}
            legendRows={5}
            rings={[{ innerRadius: 40, outerRadius: 110, segments: 4, offset: index * 0.04 }]}
          />
        </div>
      ))}
    </div>
  );
}

function DashboardOrdini({
  mobile,
  temaColori,
  utente,
  token,
  inputCont,
  setInputCont,
}) {
  const { selezioneCampiRicerca } = useLogisticaConfiguration();

  const today = new Date();
  const daysAgo30 = new Date(today);
  daysAgo30.setDate(today.getDate() - 30);

  // Calcolo date mese scorso per default statistiche
  const startLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const endLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  function formatDate(date = new Date()) {
    return [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join("-");
  }

  const [input, setInput] = useState({
    dataStartStorico: formatDate(daysAgo30),
    dataEndStorico: formatDate(today),
    dataStartDati: formatDate(startLastMonth),
    dataEndDati: formatDate(endLastMonth),
    datiOrdiniInCorso: true,
  });
  const [valoriDaPassare, setValoriDaPassare] = useState({
    dataStartStorico: formatDate(daysAgo30),
    dataEndStorico: formatDate(today),
    dataStartDati: formatDate(startLastMonth),
    dataEndDati: formatDate(endLastMonth),
    datiOrdiniInCorso: true,
  });
  const [sharingStats, setSharingStats] = useState(null);
  const [dropshippingStats, setDropshippingStats] = useState(null);
  
  // Restore needed state for Shared sections (Pies) and General Stats
  const [loadingSharing, setLoadingSharing] = useState(false);
  const [errorSharing, setErrorSharing] = useState("");
  
  const [articoliStats, setArticoliStats] = useState(null);
  const [loadingArticoli, setLoadingArticoli] = useState(false);
  const [errorArticoli, setErrorArticoli] = useState("");
  
  const [lookupMaps, setLookupMaps] = useState({});
  const [ordiniInCorsoLoaded, setOrdiniInCorsoLoaded] = useState(false);


  function aggiornaStatsRangeDate() {
    setValoriDaPassare(input);
  }

  const handleChange = async function (evt) {
    const value = evt.target.value;
    try {
      setInput({
        ...input,
        [evt.target.name]: value,
      });
    } catch (err) {
      console.log("Errore nell'aggiornamento di un dato non nestato: " + err);
      throw err;
    }
  };

  function storicoOrdini() {
    return (
      <div className="w-100 sfondoBiancoTema">
        <div className="w-100 flex flex-wrap justify-center tc">
          <div className="w-50 pa3 mw5">
            <label className="mr1 b" for="dataStartStorico">
              Da data
            </label>
            <input
              type="date"
              name="dataStartStorico"
              onChange={handleChange}
              value={input.dataStartStorico}
              className="input-reset inputOrizzontale"
            ></input>
          </div>
          <div className="w-50 pa3 mw5">
            <label className="mr1 b" for="dataEndStorico">
              a data
            </label>
            <input
              type="date"
              name="dataEndStorico"
              onChange={handleChange}
              value={input.dataEndStorico}
              className="input-reset inputOrizzontale"
            ></input>
          </div>
          <div className="w-100">
            <StoricoOrdini
              dataStart={input.dataStartStorico}
              dataEnd={input.dataEndStorico}
              token={token}
              apiUrl={apiUrl}
            />
          </div>
        </div>
      </div>
    );
  }
  function statisticheOrdini() {
    return (
      <div className="sfondoBiancoTema flex flex-wrap justify-center tc">
        <div className="w-100 flex flex-wrap justify-center items-center tc">
          <div className="w-50 pa3 mw5">
            <label className="mr1 b" for="dataStartDati">
              Da data
            </label>
            <input
              type="date"
              name="dataStartDati"
              onChange={handleChange}
              value={input.dataStartDati}
              className="input-reset inputOrizzontale"
            ></input>
          </div>
          <div className="w-50 pa3 mw5">
            <label className="mr1 b" for="dataEndDati">
              a data
            </label>
            <input
              type="date"
              name="dataEndDati"
              onChange={handleChange}
              value={input.dataEndDati}
              className="input-reset inputOrizzontale"
            ></input>
          </div>
          <button
            onClick={aggiornaStatsRangeDate}
            className="dim tastoInputOrizzontaleNoRadNoHeight br2 ml3"
          >
            {stilePulsanti.tastoCercaAspetto}
          </button>
        </div>
        <Ordinidelgiorno
          token={token}
          dataStart={valoriDaPassare.dataStartDati}
          dataEnd={valoriDaPassare.dataEndDati}
          datiOrdiniInCorso={false}
        />
      </div>
    );
  }

  const fetchSharingStats = async (tipo) => {
    const params = new URLSearchParams({
      tipo: tipo,
      dataStart: valoriDaPassare.dataStartDati,
      dataEnd: valoriDaPassare.dataEndDati,
    });
    const response = await axios.get(
      `${apiUrl}/logistica/dashboard/statisticheArticoliSharing?${params.toString()}`,
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
    return response.data;
  };



  const fetchArticoliStats = async () => {
    const params = new URLSearchParams({
      dataStart: valoriDaPassare.dataStartDati,
      dataEnd: valoriDaPassare.dataEndDati,
    });
    const response = await axios.get(
      `${apiUrl}/logistica/dashboard/statisticheArticoliSpediti?${params.toString()}`,
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
    return response.data;
  };

  const fetchLookups = async () => {
    const types = ["reparti", "categorie", "tipi", "persona", "brand"];
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    const results = await Promise.all(
      types.map(async (t) => {
        try {
          const res = await axios.get(`${apiUrl}/moda/lookup/${t}`, {
            headers,
          });
          if (res.data?.success && Array.isArray(res.data.data)) {
            const map = new Map(
              res.data.data
                .filter((r) => r?.code)
                .map((r) => [String(r.code), r.description || ""])
            );
            return [t, map];
          }
        } catch (err) {
          console.error("Errore fetch lookup", t, err);
        }
        return [t, new Map()];
      })
    );
    const obj = {};
    results.forEach(([k, v]) => {
      obj[k] = v;
    });
    setLookupMaps(obj);
  };

  useEffect(() => {
    if (!token) return;
    fetchLookups();
  }, [token]);

  useEffect(() => {
    setOrdiniInCorsoLoaded(false);
  }, [token]);

  useEffect(() => {
    const loadArticoli = async () => {
      if (!token || !ordiniInCorsoLoaded) return;
      setLoadingArticoli(true);
      setErrorArticoli("");
      try {
        const stats = await fetchArticoliStats();
        setArticoliStats(stats);
      } catch (err) {
        console.error("Errore fetch statistiche articoli generali", err);
        setErrorArticoli("Errore caricamento statistiche articoli spediti");
      } finally {
        setLoadingArticoli(false);
      }
    };
    loadArticoli();
  }, [token, ordiniInCorsoLoaded, valoriDaPassare.dataStartDati, valoriDaPassare.dataEndDati]);



  useEffect(() => {
    const load = async () => {
      if (!token || !ordiniInCorsoLoaded) return;
      setLoadingSharing(true);
      setErrorSharing("");
      try {
        const [sharing, drops] = await Promise.all([
          fetchSharingStats("inv_sharing"),
          fetchSharingStats("dropshipping"),
        ]);
        setSharingStats(sharing);
        setDropshippingStats(drops);
      } catch (err) {
        console.error("Errore fetch statistiche sharing", err);
        setErrorSharing(
          err?.response?.status
            ? `Errore ${err.response.status} caricamento statistiche articoli sharing`
            : "Errore caricamento statistiche articoli sharing"
        );
      } finally {
        setLoadingSharing(false);
      }
    };
    load();
  }, [token, ordiniInCorsoLoaded, valoriDaPassare.dataStartDati, valoriDaPassare.dataEndDati]);



  const renderPie = (title, dataArr, lookupKey) => {
    const data = Array.isArray(dataArr)
      ? dataArr
          .map((d) => ({
            label: d.label || "N/D",
            value: Number(d.value || 0),
          }))
          .sort((a, b) => b.value - a.value)
          .slice(0, 10)
      : [];
    return (
      <div className="pa2 w-100 w-20-l flex flex-column items-center">
        <div className="tc b ttu">{title}</div>
        {data.length > 0 ? (
          <>
            <PieChart
              series={[
                {
                  arcLabel: (item) =>
                    item.label && item.value > 0 ? String(item.label) : "",
                  data,
                  innerRadius: 40,
                  outerRadius: 110,
                  cx: 140,
                  cy: 120,
                },
              ]}
              colors={cheerfulFiestaPalette}
              sx={{
                [`& .${pieArcLabelClasses.root}`]: {
                  fill: "black",
                  fontWeight: "bold",
                },
              }}
              width={320}
              height={240}
              margin={{ left: 40, right: 40 }}
              legend={{ hidden: true }}
            />
            <div className="flex justify-center mt3 f7">
              <div className="flex flex-column">
                {data.map((d, idx) => (
                  <div
                    key={`${title}-${d.label}`}
                    className="flex items-start mb2"
                  >
                    <div className="tr pr2 w-60">
                      <div>
                        <div>
                          <b>{d.label}</b>
                        </div>
                        <div>
                          {lookupKey &&
                          lookupMaps?.[lookupKey] instanceof Map &&
                          lookupMaps[lookupKey].get(d.label)
                            ? `${lookupMaps[lookupKey].get(d.label)}`
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div className="tl pl2 w-40 b">
                      <span>
                        {Number(d.value || 0).toLocaleString("it-IT")} pz.
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        ) : (
          <div className="gray mt2">Nessun dato</div>
        )}
      </div>
    );
  };

  const renderTopCardList = (title, items, isImporto = false) => {
    if (!Array.isArray(items) || items.length === 0) return null;
    return (
      <div className="w-100 w-25-ns pa2">
        <div className="b tc mt3 mb3 ttu f4">{title}</div>
        <div className="flex flex-wrap">
          {items.map((item, i) => (
            <div
              key={`${title}-${item.label}-${i}`}
              className="ba b--black-10 br4 pt3 pb4 mb3 pa2 ma1 mb3 w-100 flex"
            >
              <div className="w-20 flex items-center justify-center scrittaColChiaro f1">
                {i + 1}
              </div>
              <div className="w-80">
                <div className="gray f6">{item.label}</div>
                {item.nomeArticolo && (
                  <div className="b f5">{item.nomeArticolo}</div>
                )}
                {item.brand && <div className="gray f6">Brand: {item.brand}</div>}
                {item.nomeColore && (
                  <div className="gray f6">Colore: {item.nomeColore}</div>
                )}
                {item.codProd && (
                  <div className="gray f6">Cod. prod: {item.codProd}</div>
                )}
                <div className="mt1">
                  <span className="b">{isImporto ? "Importo:" : "Quantità:"}</span>{" "}
                  {isImporto
                    ? `${Number(item.value || 0).toLocaleString("it-IT", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })} €`
                    : Number(item.value || 0)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const sezioneSharing = (titolo, stats) => (
    <div className="w-100 ba b--black-10 br2 pa3 mb3">
      <div className="tc f5 b mb2">{titolo}</div>
      <div className="flex flex-wrap items-start justify-center">
        {renderPie("Stato ordine", stats?.stati)}
        {renderPie("Reparti", stats?.reparti, "reparti")}
        {renderPie("Categorie", stats?.categorie, "categorie")}
        {renderPie("Brand", stats?.brand, "brand")}
      </div>
      {(stats?.topQty?.length || stats?.topImporto?.length) && (
        <div className="mt3 flex flex-wrap justify-center">
          {renderTopCardList("Top 10 per quantità", stats.topQty, false)}
          {renderTopCardList("Top 10 per importo", stats.topImporto, true)}
        </div>
      )}
    </div>
  );



  const bloccoPies = (titolo, stats) => (
    <div className="sfondoBiancoTema pa3">
      <div className="w-100 flex flex-wrap justify-center items-center tc mb3">
        <div className="w-50 pa2 mw5">
          <label className="mr1 b" htmlFor="dataStartDati">
            Da data
          </label>
          <input
            type="date"
            name="dataStartDati"
            onChange={handleChange}
            value={input.dataStartDati}
            className="input-reset inputOrizzontale"
          />
        </div>
        <div className="w-50 pa2 mw5">
          <label className="mr1 b" htmlFor="dataEndDati">
            a data
          </label>
          <input
            type="date"
            name="dataEndDati"
            onChange={handleChange}
            value={input.dataEndDati}
            className="input-reset inputOrizzontale"
          />
        </div>
        <button
          onClick={aggiornaStatsRangeDate}
          className="dim tastoInputOrizzontaleNoRadNoHeight br2 ml3"
        >
          {stilePulsanti.tastoCercaAspetto}
        </button>
      </div>
      <div className="gray tc mb3">
        Range applicato alle pie: {valoriDaPassare.dataStartDati} →{" "}
        {valoriDaPassare.dataEndDati}
      </div>
      {loadingSharing && <DashboardPieGroupSkeleton />}
      {errorSharing && <div className="dark-red">{errorSharing}</div>}
      {!loadingSharing && !errorSharing && sezioneSharing(titolo, stats)}
    </div>
  );



  const sezioneArticoliGenerali = () => (
    <div className="sfondoBiancoTema pa3">
      <div className="w-100 flex flex-wrap justify-center items-center tc mb3">
        <div className="w-50 pa2 mw5">
          <label className="mr1 b" htmlFor="dataStartDati">
            Da data
          </label>
          <input
            type="date"
            name="dataStartDati"
            onChange={handleChange}
            value={input.dataStartDati}
            className="input-reset inputOrizzontale"
          />
        </div>
        <div className="w-50 pa2 mw5">
          <label className="mr1 b" htmlFor="dataEndDati">
            a data
          </label>
          <input
            type="date"
            name="dataEndDati"
            onChange={handleChange}
            value={input.dataEndDati}
            className="input-reset inputOrizzontale"
          />
        </div>
        <button
          onClick={aggiornaStatsRangeDate}
          className="dim tastoInputOrizzontaleNoRadNoHeight br2 ml3"
        >
          {stilePulsanti.tastoCercaAspetto}
        </button>
      </div>
      <div className="gray tc mb3">
        Range applicato: {valoriDaPassare.dataStartDati} →{" "}
        {valoriDaPassare.dataEndDati}
      </div>
      {loadingArticoli && <DashboardPieGroupSkeleton />}
      {errorArticoli && <div className="dark-red">{errorArticoli}</div>}
      {!loadingArticoli && !errorArticoli && articoliStats && (
        <>
          <div className="flex flex-wrap items-start justify-center">
            {renderPie("Reparti", articoliStats.reparti, "reparti")}
            {renderPie("Categorie", articoliStats.categorie, "categorie")}
            {renderPie("Tipi", articoliStats.tipi, "tipi")}
            {renderPie("Persona", articoliStats.persone, "persona")}
            {renderPie("Brand", articoliStats.brand, "brand")}
          </div>
          <div className="mt3 flex flex-wrap justify-center mt3">
            <div className="w-100 w-25-ns pa2">
              <div className="b tc mt3 mb3 ttu f4">
                Top 10 articoli per quantità
              </div>
              <div className="flex flex-wrap">
                {(articoliStats.topQty || []).map((item, i) => (
                  <div
                    key={`qty-${item.label}`}
                    className="ba b--black-10 br4 pt3 pb4 mb3 pa2 ma1 mb3 w-100 flex"
                  >
                    <div className="w-20 flex items-center justify-center scrittaColChiaro f1">
                      {i + 1}
                    </div>
                    <div className="w-80">
                      <div className="gray f6">{item.label}</div>
                      {item.nomeArticolo && (
                        <div className="b f5">{item.nomeArticolo}</div>
                      )}
                      {item.brand && (
                        <div className="gray f6">Brand: {item.brand}</div>
                      )}
                      {item.nomeColore && (
                        <div className="gray f6">Colore: {item.nomeColore}</div>
                      )}
                      {item.codProd && (
                        <div className="gray f6">Cod. prod: {item.codProd}</div>
                      )}
                      <div className="mt1">
                        <span className="b">Quantità:</span> {item.value}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-100 w-25-ns pa2">
              <div className="b tc mt3 mb3 ttu f4">
                Top 10 articoli per importo
              </div>
              <div className="flex flex-wrap">
                {(articoliStats.topImporto || []).map((item, i) => (
                  <div
                    key={`imp-${item.label}`}
                    className="ba b--black-10 br4 pt3 pb4 mb3 pa2 ma1 mb3 w-100 flex"
                  >
                    <div className="w-20 flex items-center justify-center scrittaColChiaro f1">
                      {i + 1}
                    </div>
                    <div className="w-80">
                      <div className="gray f6">{item.label}</div>
                      {item.nomeArticolo && (
                        <div className="b f5">{item.nomeArticolo}</div>
                      )}
                      {item.brand && (
                        <div className="gray f6">Brand: {item.brand}</div>
                      )}
                      {item.nomeColore && (
                        <div className="gray f6">Colore: {item.nomeColore}</div>
                      )}
                      {item.codProd && (
                        <div className="gray f6">Cod. prod: {item.codProd}</div>
                      )}
                      <div className="mt1">
                        <span className="b">Importo:</span>{" "}
                        {(() => {
                          const num = Number(item.value || 0);
                          return num.toLocaleString("it-IT", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          });
                        })()}{" "}
                        €
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );


  /* New State for Dati Condivisi scope */
  const [datiCondivisiScope, setDatiCondivisiScope] = useState('all'); // all | inv_sharing | dropshipping

  const mergeStatsObjects = (s1, s2) => {
      if (!s1 && !s2) return null;
      if (!s1) return s2;
      if (!s2) return s1;

      const mergeArr = (arr1, arr2) => {
          const map = new Map();
          [...(arr1 || []), ...(arr2 || [])].forEach(item => {
              if (!item) return;
              const current = map.get(item.label) || { ...item, value: 0 };
              current.value = Number(current.value || 0) + Number(item.value || 0);
              map.set(item.label, current);
          });
          return Array.from(map.values()).sort((a,b) => b.value - a.value);
      };

      return {
          stati: mergeArr(s1.stati, s2.stati),
          reparti: mergeArr(s1.reparti, s2.reparti),
          categorie: mergeArr(s1.categorie, s2.categorie),
          brand: mergeArr(s1.brand, s2.brand),
          topQty: mergeArr(s1.topQty, s2.topQty).slice(0, 10),
          topImporto: mergeArr(s1.topImporto, s2.topImporto).slice(0, 10),
      };
  };

  const getDatiCondivisimerged = () => {
       if (datiCondivisiScope === 'inv_sharing') return sharingStats;
       if (datiCondivisiScope === 'dropshipping') return dropshippingStats;
       return mergeStatsObjects(sharingStats, dropshippingStats); // all
  };

  const sezioneDatiCondivisiRender = () => {
       const stats = getDatiCondivisimerged();
       const buttonClassesWhite = stilePulsanti.buttonClassesWhite;
       const buttonClassesGreen = stilePulsanti.buttonClassesGreen;

       return (
        <div className="sfondoBiancoTema pa3">
        <div className="w-100 flex flex-wrap justify-center items-center tc mb3">
          <div className="w-50 pa2 mw5">
            <label className="mr1 b" htmlFor="dataStartDati">
              Da data
            </label>
            <input
              type="date"
              name="dataStartDati"
              onChange={handleChange}
              value={input.dataStartDati}
              className="input-reset inputOrizzontale"
            />
          </div>
          <div className="w-50 pa2 mw5">
            <label className="mr1 b" htmlFor="dataEndDati">
              a data
            </label>
            <input
              type="date"
              name="dataEndDati"
              onChange={handleChange}
              value={input.dataEndDati}
              className="input-reset inputOrizzontale"
            />
          </div>
          <button
            onClick={aggiornaStatsRangeDate}
            className="dim tastoInputOrizzontaleNoRadNoHeight br2 ml3"
          >
            {stilePulsanti.tastoCercaAspetto}
          </button>
        </div>
        
        {/* Scope Toggle */}
        <div className="flex justify-center mb3">
             <div className='flex items-center'>
                <span className='mr2'>Scope:</span>
                <button onClick={() => setDatiCondivisiScope('all')} className={datiCondivisiScope === 'all' ? buttonClassesGreen : buttonClassesWhite}>Tutti</button>
                <button onClick={() => setDatiCondivisiScope('inv_sharing')} className={datiCondivisiScope === 'inv_sharing' ? buttonClassesGreen : buttonClassesWhite}>Inventory Sharing</button>
                <button onClick={() => setDatiCondivisiScope('dropshipping')} className={datiCondivisiScope === 'dropshipping' ? buttonClassesGreen : buttonClassesWhite}>Dropshipping</button>
             </div>
        </div>

        <div className="gray tc mb3">
          Range applicato: {valoriDaPassare.dataStartDati} →{" "}
          {valoriDaPassare.dataEndDati}
        </div>
        
        {loadingSharing && <DashboardPieGroupSkeleton />}
        {errorSharing && <div className="dark-red tc">{errorSharing}</div>}
        
        {!loadingSharing && !errorSharing && (() => {
            const hasData = stats && (
                (stats.stati && stats.stati.length > 0) || 
                (stats.topQty && stats.topQty.length > 0)
            );

            if (hasData) {
                return sezioneSharing("Dati Condivisi", stats);
            } else {
                let msgLabel = "dropshipping/inventory sharing";
                if (datiCondivisiScope === 'inv_sharing') msgLabel = "inventory sharing";
                if (datiCondivisiScope === 'dropshipping') msgLabel = "dropshipping";
                
                return <div className="tc gray mt3">Non ci sono ordini {msgLabel} nel range di date selezionato</div>;
            }
        })()}
      </div>
       )
  }

  const sections = [
    {
      id: "statOrdini",
      label: "Statistiche Ordini",
      render: statisticheOrdini,
    },
    {
      id: "statArticoli",
      label: "Statistiche Articoli",
      render: sezioneArticoliGenerali,
    },
    {
      id: "trend_reparti",
      label: "Trend Reparti",
      render: () => (
        <StatTrendFacet
          facetKey="reparti"
          title="Trend Vendite Reparti"
          mobile={mobile}
          token={token}
          lookupMap={lookupMaps.reparti}
        />
      ),
    },
    {
      id: "trend_categorie",
      label: "Trend Categorie",
      render: () => (
        <StatTrendFacet
          facetKey="categorie"
          title="Trend Vendite Categorie"
          mobile={mobile}
          token={token}
          lookupMap={lookupMaps.categorie}
        />
      ),
    },
    {
      id: "trend_tipi",
      label: "Trend Tipi",
      render: () => (
        <StatTrendFacet
          facetKey="tipi"
          title="Trend Vendite Tipi"
          mobile={mobile}
          token={token}
          lookupMap={lookupMaps.tipi}
        />
      ),
    },
    {
      id: "storico",
      label: "Storico Ordini",
      render: storicoOrdini,
    },
    {
      id: "spedAnni",
      label: "Spedizioni per Anno",
      render: () => (
        <StatSpedAnni
          mobile={mobile}
          input={inputCont}
          setInput={setInputCont}
        />
      ),
    },
    {
      id: "spedMarket",
      label: "Spedizioni Marketplace",
      render: () => <StatSpedMarketplaces mobile={mobile} />,
    },
    {
      id: "spedCorrieri",
      label: "Spedizioni Corrieri",
      render: () => <StatSpedCorrieri mobile={mobile} />,
    },
    {
      id: "spedizioni_paesi",
      label: "Top 10 Paesi",
      render: () => <StatSpedPaesi mobile={mobile} token={token} />,
    },
    {
      id: "motivi_annullamenti",
      label: "Motivi Annullamenti",
      render: () => <StatSpedMotiviAnnullamenti mobile={mobile} />,
    },
    {
      id: "grane",
      label: "Trend grane corrieri",
      render: () => <StatSpedGraneMarketplace mobile={mobile} />,
    },
    {
      id: "dati_grane",
      label: "Dati grane corrieri",
      render: () => <StatDatiGraneCorrieri token={token} />,
    },
    {
      id: "controllo_fatture_corrieri",
      label: "Controllo fatture corrieri",
      render: () => <StatControlloFattureCorrieri token={token} />,
    },
    {
      id: "dati_condivisi",
      label: "Dati dropshipping/i.s.",
      render: sezioneDatiCondivisiRender,
    },
    {
        id: "trend_condivisi",
        label: "Trend dropshipping/i.s.",
        render: () => (
            <StatTrendSharing
                mobile={mobile}
                token={token}
            />
        )
    },
    {
        id: "confronta_trend_ordini",
        label: "Confronta tutto - trend ordini",
        render: () => (
            <StatTrendConfronta
                mobile={mobile}
                token={token}
                type="ordini"
                campiRicerca={selezioneCampiRicerca.logisticaAvanzata}
                modalTitle="Filtra Ordini per Trend"
            />
        )
    },
    {
        id: "confronta_trend_articoli",
        label: "Confronta tutto - trend articoli",
        render: () => (
            <StatTrendConfronta
                mobile={mobile}
                token={token}
                type="articoli"
                campiRicerca={selezioneCampiRicerca.articoliAvanzata}
                modalTitle="Filtra Articoli per Trend"
            />
        )
    },
    {
        id: "confronta_dati",
        label: "Confronta tutto - dati",
        render: () => (
            <StatDatiConfronta
                mobile={mobile}
                token={token}
                campiRicerca={selezioneCampiRicerca.logisticaAvanzata}
            />
        )
    },
    {
      id: "incassiSpedizioni",
      label: "Incassi spedizioni",
      render: () => <StatIncassiSpedizioni />,
    }
  ];

  const [activeSection, setActiveSection] = useState(sections[0].id);
  const activeSectionCaption =
    dashboardOrdiniSectionCaptions[activeSection] || "";

  return (
    <div className="flex flex-column colonnaTuttaPagina pa2">
      {/* Sezione Fissa in Alto: Ordini in corso */}
      <div className="mb3 shadow-1 pa3 br2 sfondoBiancoTema">
        <div className="tc f4 mb2">Ordini in corso</div>
        <div className="tc mb3">
          Statistiche sugli ordini in preparazione non ancora spediti <br />
          <span className="f7 gray">
            (no attese, bonifici in attesa e inventory sharing da ricevere, sì
            inv. sharing ancora da ordinare)
          </span>
        </div>
        <Ordinidelgiorno
          token={token}
          dataStart={false}
          dataEnd={false}
          datiOrdiniInCorso={true}
          onLoad={() => setOrdiniInCorsoLoaded(true)}
        />
        <div className="mt3 pt3 bt b--black-10 gray f7 lh-copy">
          {dashboardOrdiniSectionCaptions.ordini_in_corso}
        </div>
      </div>

      {/* Layout Sidebar + Contenuto */}
      <div className="flex flex-wrap w-100 items-start">
        {/* Sidebar Navigazione */}
        <div className="w-100 w-10-l flex flex-column pr2 mb3 mb0-l">
          {sections.map((sec) => (
            <button
              key={sec.id}
              onClick={() => setActiveSection(sec.id)}
              className={`pointer pa2 mb2 bn br2 f6 tl ${
                activeSection === sec.id
                  ? "bg-blue white b"
                  : "bg-white black-80 hover-bg-light-gray"
              }`}
            >
              {sec.label}
            </button>
          ))}
        </div>

        {/* Area Contenuto */}
        <div className="w-100 w-90-l pl3-l">
          {sections.map((sec) => {
            if (sec.id !== activeSection) return null;
            return (
              <div key={sec.id} className="fade-in">
                {/* Titolo Mobile/Desktop della sezione attiva per chiarezza */}
                <div className="dn-l db tc f4 b mb3">{sec.label}</div>
                {sec.render()}
                {activeSectionCaption && (
                  <div className="mt3 pa3 br2 bg-near-white gray f7 lh-copy">
                    {activeSectionCaption}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default withLogisticaConfiguration(DashboardOrdini);
